import i18n from '../../managers/i18n'

i18n.register(
  'en-US',
  {
    uploader: 'File uploader',
    selectFile: 'Select file',
    fileTypeInvalid: 'Invalid file type',
    fileSizeInvalid: 'File size is too large',
    tooManyFiles: 'Too many files',
    uploadFailure: 'Upload failed!',
    remove: 'Remove',
    replace: 'Replace',
    preview: 'Preview',
    uploading: 'Uploading…',
    separator: '; '
  },
  {
    ns: 'uploader'
  }
)
